import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiResponseDocument,
  OpalApiRequestParams,
} from '../../schema'

export function readUser(
  params: OpalApiRequestParams<'ReadUserV2'>
): Promise<OpalApiResponseDocument<'ReadUserV2', 200>> {
  const url = new URL(
    `/users/v2/${params.path.user_id}`,
    window.location.origin
  )

  url.search = queryString(params.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
